<!--
 * @Date: 2022-03-25 16:27:21
 * @LastEditTime: 2022-03-25 16:53:14
 * @Description:
 * @FilePath: \BrainWapWebsite\pages\ftReport\index.vue
-->
<template>
  <div style="width: 100%; height: 100%">
    <iframe
      name="ft-iframe"
      class="iframe"
      :src="url"
      frameborder="0"
    />
    <!--    <web-view :src="url"></web-view>-->
  </div>
</template>

<script>
  export default {
    name: 'FtReportDetail',
    watchQuery: true,
    data() {
      return {
        url: ''
      }
    },
    mounted() {
      this.url = this.$route.query.url
      // console.log('this.url', this.url)
    },
    methods: {
    }
  }
</script>

<style scoped lang="less">
.iframe {
  height: 100%;
  width: 100%;
}

</style>
